/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Sessions_EmptyInputs */

const en_coaching_sessions_empty = /** @type {(inputs: Coaching_Sessions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No sessions yet.`)
};

const id_coaching_sessions_empty = /** @type {(inputs: Coaching_Sessions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada sesi.`)
};

/**
* | output |
* | --- |
* | "No sessions yet." |
*
* @param {Coaching_Sessions_EmptyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const coaching_sessions_empty = /** @type {((inputs?: Coaching_Sessions_EmptyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Sessions_EmptyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_coaching_sessions_empty(inputs)
	return en_coaching_sessions_empty(inputs)
});